import React from "react"
import { values, intersectionBy, sortBy } from "lodash"
import { connect } from "react-redux"
import { push, replace } from "connected-react-router"
import { parse, stringify } from "query-string"
import { SearchBar } from "react-weui"

import {products, productsByCity} from "../../../../data.json"
import Page from "../components/FixedBarPage"
import removeDiacritics from "../../../lib/diacritics"
import CoolCard from '../components/CoolCard'
import SearchMenu from "./Search.Menu"

import "./Search.less"

const clean = x => removeDiacritics(x || "").toLowerCase().replace(/\s/g, "")

const check = (x, term) => clean(x).includes(term)

class Search extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      term: this.props.term
    }
  }

  updateQuery(newQuery) {
    this.props.updateSearch({...this.props.query, ...newQuery})
  }

  toggleToday() {
    this.updateQuery({ forToday: this.props.forToday ? "0" : "1" })
  }

  filteredProducts() {
    // #TODO is this working!? is that intersection right? debug this pls
    const intersectionArray = values(products)
    const prByCitys = this.props.city ? productsByCity[this.props.city] : intersectionArray
    const prByTag = this.props.tag ? values(products).filter(prd => prd.tags && prd.tags[this.props.tag]) : intersectionArray
    return intersectionBy(intersectionArray, prByCitys, prByTag, "_id").filter(product => (product.relations ? !product.relations.isShy : true))
  }

  search(term) {
    const cleanTerm = clean(term)
    return this.filteredProducts().filter(p => (
      ["name", "spanishName", "chName", "extraTerms"]
        .some(propName => check(p[propName], cleanTerm))
    ))
  }

  render() {
    const findings = sortBy(
      this.state.term.length < 3
        ? this.filteredProducts()
        : this.search(this.state.term),
      product => -(product.rank || 0)
    )

    // #TODO this title is wrong, should change in /tickets and /restaurants 

    return (
      <Page
        title="搜索产品"
        isChevron
        containerProps={{ className: "search-page" }}
      >
        <SearchBar
          onChange={term => {
            this.setState({term})
          }}
          defaultValue={this.state.term}
          placeholder="搜索产品"
          lang={{ cancel: '取消' }}
        />

        <div className="findings" style={{display: 'flex', flexDirection: 'column'}}>
          {
            findings.map(product => (
              <div key={product._id} className="wrapper">
                <CoolCard product={product}/>
              </div>
            ))
          }
        </div>
      </Page>
    )
  }
}

const mapStateToProps = state => {
  const query = parse(state.router.location.search)
  return {
    userInfo: state.userInfo,
    wholeState: state,
    routing: state.routing,
    query,
    city: query.city || "",
    type: query.type || "",
    tag: query.tag || "",
    term: query.term || "",
    forToday: query.forToday == "1",
  }
}

const mapDispatchToProps = dispatch => ({
  push: url => dispatch(push(url)),
  updateSearch: query => dispatch(replace({search: stringify(query)})),
})

export default connect(mapStateToProps, mapDispatchToProps)(Search)



// WEBPACK FOOTER //
// ./src/app/catalogo/search/Search.jsx